(() => {
  const currentCurrency = () => window.Shopify?.currency?.active;
  const dataLayer = () => {
    window.dataLayer = window.dataLayer || [];
    return window.dataLayer;
  };

  const clean = (object) => Object.fromEntries(
    Object.entries(object).filter(([, value]) => value !== undefined && value !== null && value !== '')
  );

  const number = (value) => {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : undefined;
  };

  const cents = (value) => {
    const parsed = number(value);
    return parsed === undefined ? undefined : parsed / 100;
  };

  const id = (value) => {
    if (!value) return undefined;
    return String(value).split('?')[0].split('/').pop();
  };

  const push = (payload) => dataLayer().push(payload);

  const itemFromProduct = (product, quantity = 1) => {
    const variant = product?.selectedVariant;
    return clean({
      item_id: id(variant?.id || product?.id),
      item_name: product?.title,
      item_variant: variant?.title,
      quantity,
    });
  };

  const itemFromCartLine = (line) => {
    const amount = number(line?.cost?.totalAmount?.amount);
    return clean({
      item_id: id(line?.merchandiseId || line?.id),
      quantity: number(line?.quantity),
      price: amount && line.quantity ? amount / line.quantity : undefined,
    });
  };

  const itemFromAjaxLine = (line) => {
    const quantity = number(line?.quantity) || 1;
    const price = cents(line?.final_price ?? line?.price);
    return clean({
      item_id: id(line?.variant_id || line?.id),
      item_name: line?.product_title || line?.title,
      item_variant: line?.variant_title,
      sku: line?.sku,
      item_brand: line?.vendor,
      price,
      quantity,
    });
  };

  const itemFromDataset = (item) => clean({
    item_id: id(item?.variantId || item?.productId),
    item_name: item?.productTitle,
    item_variant: item?.variantTitle,
    price: number(item?.price),
    quantity: number(item?.quantity) || 1,
  });

  const pushProductAdded = (line) => {
    const item = itemFromAjaxLine(line);
    const quantity = item.quantity || 1;
    push({
      event: 'product_added_to_cart',
      ecommerce: clean({
        currency: line?.currency || currentCurrency(),
        value: item.price === undefined ? undefined : item.price * quantity,
        items: [item],
      }),
    });
  };

  const pushProductRemoved = (removedItem) => {
    const item = itemFromDataset(removedItem);
    const quantity = item.quantity || 1;
    push({
      event: 'product_removed_from_cart',
      ecommerce: clean({
        currency: removedItem?.currency || currentCurrency(),
        value: item.price === undefined ? undefined : item.price * quantity,
        items: [item],
      }),
    });
  };

  document.addEventListener('shopify:product:view', (event) => {
    if (event.context !== 'page') return;
    const item = itemFromProduct(event.product);
    push({
      event: 'product_viewed',
      ecommerce: { items: [item] },
      product_id: id(event.product?.id),
      product_handle: event.product?.handle,
      variant_id: id(event.product?.selectedVariant?.id),
    });
  });

  document.addEventListener('shopify:collection:view', (event) => {
    push({
      event: 'collection_viewed',
      collection_id: id(event.collection?.id),
      collection_handle: event.collection?.handle,
      products_count: event.collection?.productsCount,
      ecommerce: clean({
        item_list_id: id(event.collection?.id) || event.collection?.handle,
        item_list_name: event.collection?.handle,
        items: [],
      }),
    });
  });

  document.addEventListener('shopify:cart:view', (event) => {
    const cart = event.cart;
    const total = cart?.cost?.totalAmount;
    push({
      event: 'cart_viewed',
      cart_id: id(cart?.id),
      cart_context: event.context,
      ecommerce: clean({
        currency: total?.currencyCode || currentCurrency(),
        value: number(total?.amount),
        items: (cart?.lines || []).map(itemFromCartLine),
      }),
    });
  });

  window.OptimumGtmDataLayer = {
    pushProductAdded,
    pushProductRemoved,
  };
})();
